<template>
    <div class="position-sticky" style="top:0;">
        <!-- use v-show since DOM needs to be rendered for map -->
        <div v-show="results.length">
            <GmapMap
                style="height:100vh;"
                ref="mapRef"
                :center="centerMap"
                :zoom="14"
                :options="{ gestureHandling: 'greedy' }"
            >
                <!-- <cluster> -->
                    <gmap-custom-marker
                        class="marker-pointer"
                        :key="index"
                        v-for="(data, index) in results"
                        :marker="{ lat: data.hotel.latitude, lng: data.hotel.longitude }"
                        :zIndex="zIndexPin(data.hotel.hotelId)"
                        @click.native="scrollToItem(data.hotel.hotelId)"
                    >
                        <div v-if="activePin == data.hotel.hotelId" class="pin active">
                            <b-row class="no-gutters">
                                <b-col md="6" class="p-1">
                                    <HotelImage :result="data" />
                                </b-col>
                                <b-col md="6" class="p-2">
                                    <b-button size="sm" variant="outline-light" class="float-right">&times;</b-button>
                                    <h3 class="display-4 mb-0">
                                        <router-link :to="{ path: '/' + $i18n.locale + '/hotel/' +  convertToSlug(data.hotel.name) + '/' + toHex(data.hotel.hotelId), query: $route.query }" class="text-white">
                                            {{ data.hotel.name }}
                                        </router-link>
                                    </h3>
                                    <div v-for="offer in data.offers" :key="offer.id">
                                        <Price :exchangerates="exchangerates" :offer="offer" />
                                        <b-button variant="outline-primary" class="text-light" :to="{ path: '/' + $i18n.locale + '/hotel/' +  convertToSlug(data.hotel.name) + '/' + toHex(data.hotel.hotelId), query: $route.query }">
                                            See availability
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else class="pin">
                            <div v-for="offer in data.offers" :key="offer.id">
                                <div v-if="offer.roomQuantity > 1">
                                    <template v-if="offer.price.total">
                                        {{ formatPrice(offer.price.total * offer.roomQuantity, offer.price.currency, exchangerates) }}
                                    </template>
                                    <template v-else>
                                        {{ formatPrice(offer.price.base * offer.roomQuantity, offer.price.currency, exchangerates) }}
                                    </template>
                                </div>
                                <div v-else>
                                    <template v-if="offer.price.total">
                                        {{ formatPrice(offer.price.total, offer.price.currency, exchangerates) }}
                                    </template>
                                    <template v-else>
                                        {{ formatPrice(offer.price.base, offer.price.currency, exchangerates) }}
                                    </template>
                                </div>
                            </div>
                        </div>
                    </gmap-custom-marker>
                <!-- </cluster> -->
            </GmapMap>
        </div>
        <div v-if="results.length < 1">
            <content-placeholders :rounded="true" :centered="true">
                <content-placeholders-img style="height:100vh;"/>
            </content-placeholders>
        </div>
    </div>
</template>


<script>
    import GmapCustomMarker from "vue2-gmap-custom-marker"
    import dayjs from 'dayjs'
    import HotelImage from '@/components/ui/HotelImage'
    import Price from '@/components/ui/Price'

    export default {
        name: 'HotelMapResults',
        components: {
            "gmap-custom-marker": GmapCustomMarker,
            HotelImage,
            Price,
        },
        data () {
            return {
                activePin: false,
            }
        },
        props: {
            results: {
                type: Array,
                required: true
            },
            search: {
                type: Object,
                required: true
            },
            exchangerates: {
                type: Object,
                required: true
            }
        },
        computed: {
            centerMap() {
                return {
                    lat: 0,
                    lng: 0
                };
            }
        },
        watch: {
            results: function() {
                this.setBounds();
            }
        },
        methods: {
            zIndexPin(item) {
                if (this.activePin == item) {
                    return 51;
                }
                return 50;
            },
            convertToSlug(text) {
                return text
                    .toLowerCase()
                    .replace(/[^\w ]+/g,'')
                    .replace(/ +/g,'-')
                ;
            },
            toHex(a) {
                var s = unescape(encodeURIComponent(a))
                var h = ''
                for (var i = 0; i < s.length; i++) {
                    h += s.charCodeAt(i).toString(16)
                }
                return h
            },
            formatPrice(value, currency, exchangerates) {

                if (Object.keys(exchangerates).length > 0 && currency) {
                    let rate = value * exchangerates[currency].rate;
                    return this.currency(exchangerates[currency].target) + (rate/1).toFixed(exchangerates[currency].targetDecimalPlaces).replace('.', ',');
                }

                let val = (value/1).toFixed(2).replace('.', ',')
                return this.currency(currency) + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            currency(iso) {
                if (iso == 'EUR') {
                    return '€';
                }
                if (iso == 'USD') {
                    return '$';
                }
                if (iso == 'AUD') {
                    return '$';
                }
                if (iso == 'CAD') {
                    return '$';
                }
                if (iso == 'GBP') {
                    return '£';
                }
            },
            scrollToItem(index) {
                const elm = document.getElementById(index);
                elm.scrollIntoView({behavior: "smooth", block: "center"});

                if (this.activePin == index) {
                    this.activePin = false;
                    return;
                }

                this.activePin = index;
            },
            dateDifference(date1, date2) {
                var a = dayjs(date2, "YYYY-MM-DD");
                var b = dayjs(date1, "YYYY-MM-DD");
                return a.diff(b, 'days');
            },
            capitalize(s) {
                if (typeof s !== 'string') return '';
                return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
            },
            setBounds() {
                this.$refs.mapRef.$mapPromise.then(() => {
                    const google = window.google;
                    var bounds = new google.maps.LatLngBounds();
                    
                    for (let data of this.results) {
                        bounds.extend({ lat: data.hotel.latitude, lng: data.hotel.longitude })
                    }

                    this.$refs.mapRef.fitBounds(bounds);
                    this.$refs.mapRef.panToBounds(bounds);
                });
            }
        }
    }

    /*
    computed: {
        centerMap() {
            if (this.initialFetch) {
                return this.activePinLoc
                    ? this.activePinLoc
                    : this.pagedItemsLocations[0].loc;
            } else {
                if (this.activePinLoc) {
                    return this.activePinLoc;
                } else {
                    return null;
                }
            }
        }
    }
    */
</script>

<style scoped>
    .pin{
        background-color:#0040C1;
        padding:0.25rem 0.25rem;
        color:#fff;
        border-radius:5px;
        border:2px solid #fff;
        font-weight:bold;
        max-width:350px;
    }
    .pin::after {
        border-left: 0.375rem solid transparent;
        border-right: 0.375rem solid transparent;
        border-top: 0.375rem solid #0040C1;
        content: '';
        margin-top: -1px;
        position: absolute;
        top: 100%;
        left:50%;
        margin-left:-5px;
    }
    .gallery {
        height: 100% !important;
        width: 100% !important;
        min-height: 250px;
        min-width:250px;
    }

    .gallery {
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }

    .placeholder-img{
        background-image: url('~@/assets/placeholder.jpg');
        height:100%;
        width:100%;
        background-size: cover;
    }
</style>

<style>
    .cluster div {
        background-color:rgb(0, 64, 193, 0.85);
        border-radius:100%;
        font-weight:bold;
        max-width:350px;
        border:2px solid #fff;
    }
    .cluster span{
         line-height:0;
         color:#fff;
         font-size:1rem;
         position: relative;
        bottom: -2px;
     }
     .cluster img{
         display:none !important;
     }
</style>